module.exports = __webpack_public_path__ + "img/support.a02d08b7.png";